(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ywsj", function(module, exports) {
parcelRequire("6qcK6");

});
parcelRegister("6qcK6", function(module, exports) {
parcelRequire("3gsTl");
parcelRequire("5EXqA");
parcelRequire("iT7pl");
parcelRequire("kN2au");

});
parcelRegister("3gsTl", function(module, exports) {
"use strict";
const $2609470222b1659f$var$widgets = document.querySelectorAll(".widget_categories, .widget_nav_menu, .widget_pages");
const $2609470222b1659f$var$arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512">
<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
</svg>`;
$2609470222b1659f$var$widgets.forEach((widget)=>{
    const title = widget.querySelector(".widgettitle");
    if (!title) return;
    title.insertAdjacentHTML("beforeend", `<span class="widget__dropdown-btn">${$2609470222b1659f$var$arrowSvg}</span>`);
    const dropdownButton = title.querySelector(".widget__dropdown-btn");
    const handleSubmenu = (event)=>{
        event.preventDefault();
        widget.classList.toggle("--open");
    };
    dropdownButton?.addEventListener("click", handleSubmenu);
});

});

parcelRegister("5EXqA", function(module, exports) {
parcelRequire("7oN3a");
parcelRequire("8TwYC");
parcelRequire("kNzkh");

});
parcelRegister("7oN3a", function(module, exports) {
"use strict";
// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:
//<a href="images/content/sample-02.jpg">
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
// Converts to:
//<a href="images/content/sample-02.jpg" data-fancybox>
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
const $5630d2a021cd5f07$var$links = document.querySelectorAll(".entry-content .kt-img-link, .entry-content a");
$5630d2a021cd5f07$var$links.forEach((link)=>{
    const image = link.querySelector(':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img');
    if (!image) return;
    link.setAttribute("data-fancybox", "");
    const alignsClasses = [
        "aligncenter",
        "alignright",
        "alignleft"
    ];
    alignsClasses.forEach((align)=>{
        if (!image.classList.contains(align)) return;
        image.classList.remove(align);
        link.classList.add(align);
    });
});

});

parcelRegister("8TwYC", function(module, exports) {
"use strict";
const $679d0a49f8589b30$var$iframes = document.querySelectorAll(".entry-content iframe");
$679d0a49f8589b30$var$iframes.forEach((iframe)=>{
    const iframeSrc = iframe.getAttribute("src");
    if (!iframeSrc) return;
    if (iframeSrc.indexOf("youtube") !== -1) {
        iframe.classList.add("embed-responsive-item");
        iframe.removeAttribute("height");
        iframe.removeAttribute("width");
        const iframeWrap = document.createElement("div");
        iframeWrap.classList.add("ratio", "ratio-16x9");
        iframe.parentNode?.insertBefore(iframeWrap, iframe);
        iframeWrap.appendChild(iframe);
    }
});

});

parcelRegister("kNzkh", function(module, exports) {
"use strict";
const $f243c94214d844ef$var$removeWidthHeight = (selector)=>{
    const elements = document.querySelectorAll(selector);
    elements.forEach((element)=>{
        element.removeAttribute("width");
        element.removeAttribute("height");
        element.style.setProperty("width", null);
        element.style.setProperty("height", null);
    });
};
$f243c94214d844ef$var$removeWidthHeight(".entry-content table");
$f243c94214d844ef$var$removeWidthHeight(".entry-content tr");
$f243c94214d844ef$var$removeWidthHeight(".entry-content th");
$f243c94214d844ef$var$removeWidthHeight(".entry-content td");

});


parcelRegister("iT7pl", function(module, exports) {
// Added submenu button, in order to dropdown submenu
// Style sub-menu__button element to your needs
const $dc031c1106284b94$var$arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512">
<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
</svg>`;
const $dc031c1106284b94$var$itemsWithSubmenu = document.querySelectorAll(".menu-item-has-children, .page_item_has_children");
$dc031c1106284b94$var$itemsWithSubmenu.forEach((item)=>{
    item.insertAdjacentHTML("beforeend", `<span class="sub-menu__button">${$dc031c1106284b94$var$arrowSvg}</span>`);
    const submenuButton = item.querySelector(".sub-menu__button");
    const handleSubmenu = (event)=>{
        event.preventDefault();
        item.classList.toggle("--open");
    };
    submenuButton?.addEventListener("click", handleSubmenu);
});

});

parcelRegister("kN2au", function(module, exports) {
"use strict";
const $f22a10cefcbbd4c3$var$initGallery = (gallerySelector, galleryLinkSelector, postfix = "I")=>{
    const galleries = document.querySelectorAll(gallerySelector);
    let galleryId = `gallery-${postfix}`;
    galleries.forEach((gallery)=>{
        const links = gallery.querySelectorAll(galleryLinkSelector);
        links.forEach((link)=>{
            link.setAttribute("data-fancybox", galleryId);
        });
        galleryId += postfix;
    });
};
$f22a10cefcbbd4c3$var$initGallery(".gallery", ".gallery-icon a");
$f22a10cefcbbd4c3$var$initGallery(".wp-block-gallery", ".blocks-gallery-item a", "W");

});



})();
//# sourceMappingURL=main.7494732b.js.map
